import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import RecibeForm from "@components/forms/RecibeForm";

const RecibeAddEdit = () => {
  const params = useParams()
  const { id: recibeId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!recibeId ? 'Agregar' : 'Editar'} Recibo`}
      backUrl="/user/recibes"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "recibeForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <RecibeForm
        formId="recibeForm"
        id={recibeId}
        saveRedirectUrl="/user/recibes"
      ></RecibeForm>

    </PageContainer>
  );
}

export default RecibeAddEdit;
